import React from 'react';
import RadioButton from 'components/Inputs/RadioButton';
import classNames from 'classnames';
import { ItemsIcon, StoreIcon } from './Icons';
import './styles.scss';

const handleClick = (event, selected, onSelect) => {
  if (!selected) {
    event.preventDefault();
    onSelect();
  }
};

export type typeOfGroup = 'store' | 'items';

type GroupTypeCardType = {
  type: typeOfGroup;
  description: string;
  selected?: boolean;
  title: string;
  onSelect: () => void;
};

const GroupTypeCard: React.FC<GroupTypeCardType> = ({
  type,
  description,
  selected = false,
  title,
  onSelect,
}) => {
  const mainClass = classNames({
    'group-type-card': true,
    selected: selected,
  });
  const fill = selected ? '#1ca6f2' : '#2f373f';
  return (
    <div className={mainClass} onClick={(event) => handleClick(event, selected, onSelect)}>
      <div className="radio-button-container">
        <RadioButton
          value={selected ? 1 : null}
          options={[{ id: 1, label: '' }]}
          onChange={() => onSelect}
        />
      </div>
      <div className="body-card">
        <div style={{ marginTop: '1.5rem' }}>
          {type === 'store' ? <StoreIcon fill={fill} /> : <ItemsIcon fill={fill} />}
        </div>
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
};

export default GroupTypeCard;
